import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.scss";

import logo from "../../assets/images/cm-logo-transparent.png";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isModulesDropdownOpen, setIsModulesDropdownOpen] = useState(false);
  const [isFeaturesDropdownOpen, setIsFeaturesDropdownOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsModulesDropdownOpen(false);
    setIsFeaturesDropdownOpen(false);
    setIsServicesDropdownOpen(false);
  };

  const toggleModulesDropdown = () => {
    setIsModulesDropdownOpen(!isModulesDropdownOpen);
  };

  const closeModulesDropdown = () => {
    setIsModulesDropdownOpen(false);
  };

  const toggleFeaturesDropdown = () => {
    setIsFeaturesDropdownOpen(!isFeaturesDropdownOpen);
  };

  const closeFeaturesDropdown = () => {
    setIsFeaturesDropdownOpen(false);
  };

  const toggleServicesDropdown = () => {
    setIsServicesDropdownOpen(!isServicesDropdownOpen);
  };

  const closeServicesDropdown = () => {
    setIsServicesDropdownOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div
        className="header-container"
        onClick={(e) => {
          // Close dropdowns when clicking outside of them
          if (!e.target.closest('.dropdown')) {
            setIsModulesDropdownOpen(false);
            setIsFeaturesDropdownOpen(false);
            setIsServicesDropdownOpen(false);
          }
        }}
      >
        <div className="header-logo">
          <Link to="/" onClick={closeMobileMenu}>
            <img src={logo} alt="CashManager by D.Vision" height="75" />
          </Link>
        </div>

        <nav className={`header-nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item dropdown">
              <span
                className={`nav-link dropdown-toggle ${isActive('/automatic-bank-reconciliation') || isActive('/bank-integration') || isActive('/electronic-invoicing') || isActive('/erp-crm-integration') || isActive('/incoming-invoice-processing') || isActive('/scheduled-tasks') ? 'active' : ''}`}
                onClick={toggleModulesDropdown}
                onMouseEnter={() => !isMobileMenuOpen && setIsModulesDropdownOpen(true)}
                onMouseLeave={() => !isMobileMenuOpen && setIsModulesDropdownOpen(false)}
              >
                Modules
              </span>
              <ul
                className={`dropdown-menu ${isModulesDropdownOpen ? 'show' : ''}`}
                onMouseEnter={() => !isMobileMenuOpen && setIsModulesDropdownOpen(true)}
                onMouseLeave={() => !isMobileMenuOpen && setIsModulesDropdownOpen(false)}
              >
                <li>
                  <Link
                    to="/automatic-bank-reconciliation"
                    className={`dropdown-link ${isActive('/automatic-bank-reconciliation') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeModulesDropdown();
                    }}
                  >
                    Automatic bank reconciliation
                  </Link>
                </li>
                <li>
                  <Link
                    to="/bank-integration"
                    className={`dropdown-link ${isActive('/bank-integration') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeModulesDropdown();
                    }}
                  >
                    Bank integration
                  </Link>
                </li>
                <li>
                  <Link
                    to="/electronic-invoicing"
                    className={`dropdown-link ${isActive('/electronic-invoicing') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeModulesDropdown();
                    }}
                  >
                    Electronic invoicing
                  </Link>
                </li>
                <li>
                  <Link
                    to="/erp-crm-integration"
                    className={`dropdown-link ${isActive('/erp-crm-integration') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeModulesDropdown();
                    }}
                  >
                    ERP integration
                  </Link>
                </li>
                <li>
                  <Link
                    to="/incoming-invoice-processing"
                    className={`dropdown-link ${isActive('/incoming-invoice-processing') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeModulesDropdown();
                    }}
                  >
                    Incoming invoice processing
                  </Link>
                </li>
                <li>
                  <Link
                    to="/scheduled-tasks"
                    className={`dropdown-link ${isActive('/scheduled-tasks') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeModulesDropdown();
                    }}
                  >
                    Scheduled tasks
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown">
              <span
                className={`nav-link dropdown-toggle ${isActive('/authentication-and-signing') || isActive('/user-rights-management') || isActive('/comprehensive-financial-management') || isActive('/customizations') ? 'active' : ''}`}
                onClick={toggleFeaturesDropdown}
                onMouseEnter={() => !isMobileMenuOpen && setIsFeaturesDropdownOpen(true)}
                onMouseLeave={() => !isMobileMenuOpen && setIsFeaturesDropdownOpen(false)}
              >
                Features
              </span>
              <ul
                className={`dropdown-menu ${isFeaturesDropdownOpen ? 'show' : ''}`}
                onMouseEnter={() => !isMobileMenuOpen && setIsFeaturesDropdownOpen(true)}
                onMouseLeave={() => !isMobileMenuOpen && setIsFeaturesDropdownOpen(false)}
              >
                <li>
                  <Link
                    to="/authentication-and-signing"
                    className={`dropdown-link ${isActive('/authentication-and-signing') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeFeaturesDropdown();
                    }}
                  >
                    Authentication and signing
                  </Link>
                </li>
                <li>
                  <Link
                    to="/customizations"
                    className={`dropdown-link ${isActive('/customizations') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeFeaturesDropdown();
                    }}
                  >
                    Customizations
                  </Link>
                </li>
                <li>
                  <Link
                    to="/comprehensive-financial-management"
                    className={`dropdown-link ${isActive('/comprehensive-financial-management') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeFeaturesDropdown();
                    }}
                  >
                    Financial management system
                  </Link>
                </li>
                <li>
                  <Link
                    to="/user-rights-management"
                    className={`dropdown-link ${isActive('/user-rights-management') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeFeaturesDropdown();
                    }}
                  >
                    User rights management
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown">
              <span
                className={`nav-link dropdown-toggle ${isActive('/services') || isActive('/support-and-maintenance') || isActive('/data-migration') || isActive('/user-training') || isActive('/custom-development') ? 'active' : ''}`}
                onClick={toggleServicesDropdown}
                onMouseEnter={() => !isMobileMenuOpen && setIsServicesDropdownOpen(true)}
                onMouseLeave={() => !isMobileMenuOpen && setIsServicesDropdownOpen(false)}
              >
                Services
              </span>
              <ul
                className={`dropdown-menu ${isServicesDropdownOpen ? 'show' : ''}`}
                onMouseEnter={() => !isMobileMenuOpen && setIsServicesDropdownOpen(true)}
                onMouseLeave={() => !isMobileMenuOpen && setIsServicesDropdownOpen(false)}
              >

                <li>
                  <Link
                    to="/custom-development"
                    className={`dropdown-link ${isActive('/custom-development') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeServicesDropdown();
                    }}
                  >
                    Custom development
                  </Link>
                </li>
                <li>
                  <Link
                    to="/data-migration"
                    className={`dropdown-link ${isActive('/data-migration') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeServicesDropdown();
                    }}
                  >
                    Data migration
                  </Link>
                </li>
                <li>
                  <Link
                    to="/support-and-maintenance"
                    className={`dropdown-link ${isActive('/support-and-maintenance') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeServicesDropdown();
                    }}
                  >
                    Support and maintenance
                  </Link>
                </li>
                <li>
                  <Link
                    to="/user-training"
                    className={`dropdown-link ${isActive('/user-training') ? 'active' : ''}`}
                    onClick={() => {
                      closeMobileMenu();
                      closeServicesDropdown();
                    }}
                  >
                    User training
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link
                to="/onboarding"
                className={`nav-link ${isActive('/onboarding') ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                Pricing
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/contact"
                className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                Contact
              </Link>
            </li>
            <li className="nav-item">
              <a href="https://app.cashmanager.lv/login" target="_blank" rel="noopener noreferrer">
                <button className="btn btn-secondary">Login</button>
              </a>
            </li>
          </ul>
        </nav>

        <button
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>
    </header>
  );
};

export default Header;


